import { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth.js';
import { fetchClients } from '../api/clients.js';

const ClientsContext = createContext({ clients: [], loading: true });

export function ClientsProvider({ children }) {
  const { getToken } = useAuth();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const { data } = await fetchClients(token, {});
        if (!cancelled) setClients(data || []);
      } catch {
        // non-fatal — pages degrade gracefully with an empty list
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ClientsContext.Provider value={{ clients, loading }}>
      {children}
    </ClientsContext.Provider>
  );
}

export function useClients() {
  return useContext(ClientsContext);
}
